module.exports = __webpack_public_path__ + "6e9366a623ce966ed6788b3414b69af1.svg";